<template>
  <nav cy="side-menu"
       class="side-menu flex columns flex-between">
    <div>
      <figure class="text-center">
        <svg width="35px" height="33px" viewBox="0 0 35 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M0.701377158,3.64327246 C0.565240342,3.45230816 0.463139261,3.25452668 0.395070852,3.04992207 C0.327002444,2.84531747 0.29296875,2.60661568 0.29296875,2.33380954 C0.29296875,2.08828402 0.327002444,1.85640228 0.395070852,1.63815737 C0.463139261,1.41991246 0.565240342,1.22895103 0.701377158,1.06526734 C0.837513975,0.90158366 0.996337879,0.77882274 1.17785363,0.696980898 C1.35936939,0.615139057 1.55222699,0.57421875 1.75643221,0.57421875 L32.8295053,0.57421875 C33.0337105,0.57421875 33.2265681,0.615139057 33.4080839,0.696980898 C33.5895996,0.77882274 33.7484235,0.90158366 33.8845603,1.06526734 C34.0206972,1.22895103 34.1227982,1.41991246 34.1908666,1.63815737 C34.2589351,1.85640228 34.2929688,2.08828402 34.2929688,2.33380954 C34.2929688,2.60661568 34.2589351,2.84531747 34.1908666,3.04992207 C34.1227982,3.25452668 34.0206972,3.45230816 33.8845603,3.64327246 C33.7484235,3.80695614 33.5895996,3.92971706 33.4080839,4.0115589 C33.2265681,4.09340074 33.0337105,4.13432105 32.8295053,4.13432105 L1.75643221,4.13432105 C1.55222699,4.13432105 1.35936939,4.09340074 1.17785363,4.0115589 C0.996337879,3.92971706 0.837513975,3.80695614 0.701377158,3.64327246 Z M33.8845603,15.3056766 C34.0206972,15.4693602 34.1227982,15.6603217 34.1908666,15.8785666 C34.2589351,16.0968115 34.2929688,16.3286932 34.2929688,16.5742188 C34.2929688,16.8197443 34.2589351,17.051626 34.1908666,17.2698709 C34.1227982,17.4881158 34.0206972,17.6790773 33.8845603,17.8427609 C33.7484235,18.0064446 33.5895996,18.1292056 33.4080839,18.2110474 C33.2265681,18.2928892 33.0337105,18.3338095 32.8295053,18.3338095 L1.75643221,18.3338095 C1.55222699,18.3338095 1.35936939,18.2928892 1.17785363,18.2110474 C0.996337879,18.1292056 0.837513975,18.0064446 0.701377158,17.8427609 C0.565240342,17.6790773 0.463139261,17.4881158 0.395070852,17.2698709 C0.327002444,17.051626 0.29296875,16.8197443 0.29296875,16.5742188 C0.29296875,16.3286932 0.327002444,16.0968115 0.395070852,15.8785666 C0.463139261,15.6603217 0.565240342,15.4693602 0.701377158,15.3056766 C0.837513975,15.1419929 0.996337879,15.0192319 1.17785363,14.9373901 C1.35936939,14.8555483 1.55222699,14.814628 1.75643221,14.814628 L32.8295053,14.814628 C33.0337105,14.814628 33.2265681,14.8555483 33.4080839,14.9373901 C33.5895996,15.0192319 33.7484235,15.1419929 33.8845603,15.3056766 Z M33.8845603,29.505165 C34.0206972,29.6688487 34.1227982,29.8598102 34.1908666,30.0780551 C34.2589351,30.2963 34.2929688,30.5281817 34.2929688,30.7737072 C34.2929688,31.0465134 34.2589351,31.2852152 34.1908666,31.4898198 C34.1227982,31.6944244 34.0206972,31.8922059 33.8845603,32.0831702 C33.7484235,32.2468538 33.5895996,32.3696148 33.4080839,32.4514566 C33.2265681,32.5332984 33.0337105,32.5742188 32.8295053,32.5742188 L1.75643221,32.5742188 C1.55222699,32.5742188 1.35936939,32.5332984 1.17785363,32.4514566 C0.996337879,32.3696148 0.837513975,32.2468538 0.701377158,32.0831702 C0.565240342,31.8922059 0.463139261,31.6944244 0.395070852,31.4898198 C0.327002444,31.2852152 0.29296875,31.0465134 0.29296875,30.7737072 C0.29296875,30.5281817 0.327002444,30.2963 0.395070852,30.0780551 C0.463139261,29.8598102 0.565240342,29.6688487 0.701377158,29.505165 C0.837513975,29.3414814 0.996337879,29.2187204 1.17785363,29.1368786 C1.35936939,29.0550368 1.55222699,29.0141164 1.75643221,29.0141164 L32.8295053,29.0141164 C33.0337105,29.0141164 33.2265681,29.0550368 33.4080839,29.1368786 C33.5895996,29.2187204 33.7484235,29.3414814 33.8845603,29.505165 Z" id="" fill="#2ABB9C" fill-rule="nonzero"></path>
          </g>
        </svg>
      </figure>

      <ul cy="menu-items">
        <li cy="menu-item"
            v-for="(item,key) in menu"
            :key="key">
          <router-link :data-test="'route-to-' + key" :to="'/' + key">
            <span>{{ item }}</span>
          </router-link>
        </li>
      </ul>

      <figure class="text-center">
        <i class="pointer"
           @click="$store.dispatch('logout')">
          <svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M21.4087385,24.5537109 C19.2641564,26.1585367 16.8607814,26.9609375 14.1985416,26.9609375 C12.5346417,26.9609375 10.9539605,26.6399772 9.45645054,25.9980469 C7.99591617,25.3561166 6.70179121,24.4593157 5.57403683,23.3076172 C4.44628244,22.1559187 3.57736997,20.8343174 2.96727334,19.3427734 C2.32020115,17.8134689 1.99666991,16.1992272 1.99666991,14.5 C1.99666991,12.8007728 2.3109574,11.1865311 2.93954181,9.65722656 C3.56812622,8.16568265 4.44628244,6.84408128 5.57403683,5.69238281 C6.70179121,4.54068435 7.99591617,3.65332343 9.45645054,3.03027344 C10.9539605,2.36946284 12.5346417,2.0390625 14.1985416,2.0390625 C16.8607814,2.0390625 19.2641564,2.84146333 21.4087385,4.44628906 C21.6305918,4.61621179 21.8755511,4.67757185 22.1436239,4.63037109 C22.4116967,4.58317034 22.6289248,4.4462902 22.7953148,4.21972656 C22.9617048,3.99316293 23.026411,3.74300267 22.9894355,3.46923828 C22.9524599,3.19547389 22.8230474,2.97363366 22.6011941,2.80371094 C20.1053442,0.934560967 17.3044881,0 14.1985416,0 C12.2758128,0 10.4363066,0.377600391 8.6799678,1.1328125 C6.97909233,1.86914431 5.47236113,2.90754538 4.15972898,4.24804688 C2.84709682,5.58854837 1.83028435,7.12726996 1.10926106,8.86425781 C0.369749989,10.6578866 0,12.5364485 0,14.5 C0,16.4635515 0.369749989,18.3421134 1.10926106,20.1357422 C1.83028435,21.87273 2.84709682,23.4114516 4.15972898,24.7519531 C5.47236113,26.0924546 6.97909233,27.1308557 8.6799678,27.8671875 C10.4363066,28.6223996 12.2758128,29 14.1985416,29 C17.3044881,29 20.1053442,28.065439 22.6011941,26.1962891 C22.8230474,26.0263663 22.9524599,25.8045261 22.9894355,25.5307617 C23.026411,25.2569973 22.9663267,25.0068371 22.8091805,24.7802734 C22.6520344,24.5537098 22.4348063,24.4168297 22.1574897,24.3696289 C21.880173,24.3224281 21.6305918,24.3837882 21.4087385,24.5537109 Z M28.71875,13.244186 C28.9062509,13.4573654 29,13.7093009 29,14 C29,14.2906991 28.9062509,14.5426346 28.71875,14.755814 L24.89375,18.6802326 C24.687499,18.8934119 24.4437514,19 24.1625,19 C23.8812486,19 23.6421885,18.8982568 23.4453125,18.6947674 C23.2484365,18.4912781 23.15,18.2441875 23.15,17.9534884 C23.15,17.6627892 23.253124,17.4108538 23.459375,17.1976744 L25.540625,15.0465116 L12.0125,15.0465116 C11.7312486,15.0465116 11.4921885,14.9447685 11.2953125,14.7412791 C11.0984365,14.5377897 11,14.2906991 11,14 C11,13.7093009 11.0984365,13.4622103 11.2953125,13.2587209 C11.4921885,13.0552315 11.7312486,12.9534884 12.0125,12.9534884 L25.540625,12.9534884 L23.459375,10.8023256 C23.253124,10.5891462 23.15,10.3372108 23.15,10.0465116 C23.15,9.7558125 23.2484365,9.50872195 23.4453125,9.30523256 C23.6421885,9.10174317 23.8812486,9 24.1625,9 C24.4437514,9 24.687499,9.10658808 24.89375,9.31976744 L28.71875,13.244186 Z" id="" fill="#6C6C6C" fill-rule="nonzero"></path>
            </g>
          </svg>
        </i>
      </figure>
    </div>

    <figure>
      <img class="w100"
           src="../assets/logo.svg"
           alt="logo">
      <p class="version-number text-center mtop12px">v 2.4.2</p>
    </figure>
  </nav>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: 'SideMenu',
    computed: {
      ...mapState({
        isLogged: 'isLogged',
        user: 'user'
      }),
      menu () {
        let data;
        switch (this.user.rol) {
          case 'dinstitute_admin':
            data = {
              pacienti: 'PACIENȚI',
              reviews: 'REVIEWS',
              utilizatori: 'UTILIZATORI',
              statistici: 'STATISTICI',
            }
            break;
          case 'sterilizare':
            data = {
              sterilizare: 'STERILIZARE'
            }
            break;
          default:
            data = {
              pacienti: 'PACIENȚI',
              reviews: 'REVIEWS',
              utilizatori: 'UTILIZATORI',
              statistici: 'STATISTICI',

            }
            break;
        }
        return data
      }
    }
  }
</script>

<style lang="less">
  .side-menu {
    @media only screen and (min-width: 0) {
      width: 242px;
      padding-bottom: 48px;
      margin-right: 74px;
      box-shadow: 14px 0 10px -5px rgba(0, 0, 0, .1);
      figure:last-child {
        width: 160px;
        margin: 0 auto!important;
      }
      & > div > figure {
        padding: 35px 0;
      }
      li {
        border-bottom: 1px solid lightgrey;
        &:hover {
          background-color: #f6f6f6;
        }
      }
      a {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.8rem;
        color: gray;
        span {
          transform: translateY(3px);
        }
      }
      .version-number {
        font-size: 1.4rem;
        font-weight: 700;
        opacity: 0.5;
      }
    }

    @media only screen and (min-width: 1024px) {
      //margin-right: 0;
      //width: initial;
    }
  }
</style>
